<template>
  <div class="skeleton-loader">
    <div v-for="(c, idx) in campaigns" :key="'skeleton-' + rowKey(c, idx)" class="skeleton-campaign">
      <div class="skeleton-campaign__row">
        <div class="skeleton-campaign__cell skeleton-campaign__name">
          <div class="skeleton-line skeleton-line--title"></div>
          <div class="skeleton-line skeleton-line--subtitle"></div>
        </div>
        <div class="skeleton-campaign__cell skeleton-campaign__status">
          <div class="skeleton-badge"></div>
        </div>
        <div class="skeleton-campaign__cell skeleton-campaign__period">
          <div class="skeleton-line"></div>
        </div>
        <div class="skeleton-campaign__cell skeleton-campaign__actions">
          <div class="skeleton-button"></div>
        </div>
        <div class="skeleton-campaign__cell skeleton-campaign__count">
          <div class="skeleton-badge"></div>
        </div>
        <div class="skeleton-campaign__cell skeleton-campaign__delete">
          <div class="skeleton-button"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignsSkeleton',
  props: {
    campaigns: {
      type: Array,
      required: true
    }
  },
  methods: {
    rowKey(c, idx) {
      return String(c.external_id || c.id || `row-${idx}`)
    }
  }
}
</script>
